"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.load.error': 'Errore nel caricamento dei dati slot',
};
